import { render, staticRenderFns } from "./SpecialistIcon.vue?vue&type=template&id=3c88da90&scoped=true&"
import script from "./SpecialistIcon.vue?vue&type=script&lang=js&"
export * from "./SpecialistIcon.vue?vue&type=script&lang=js&"
import style0 from "./SpecialistIcon.vue?vue&type=style&index=0&id=3c88da90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c88da90",
  null
  
)

export default component.exports